export default "__VITE_ASSET__Dx5VZZtN__"